import { Input } from '@attentive-platform/stem-ui';

import TrashIcon from '../../../Assets/TrashIcon';

const CallbackHeadersTable = ({ headers, localId, onUpdateHeader, onRemoveHeader, onAddHeader }) => (
  <div className='mt-4'>
    <span className='text-sm font-medium text-gray-700 block mb-2'>Headers</span>
    <div className='border border-gray-200 rounded-md overflow-hidden'>
      <table className='w-full text-sm'>
        <thead className='bg-gray-50'>
          <tr>
            <th className='text-left p-3 font-medium text-gray-700'>Header Key</th>
            <th className='text-left p-3 font-medium text-gray-700'>Value</th>
            <th className='text-left p-3 font-medium text-gray-700 w-20'>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr className='border-t border-gray-100'>
            <td colSpan={3} className='p-3 cursor-pointer text-blue-600' onClick={() => onAddHeader(localId)}>
              + Create new
            </td>
          </tr>
          {headers.map((h, hi) => (
            <tr key={hi} className='border-t border-gray-100'>
              <td className='p-3'>
                <Input
                  value={h.key}
                  placeholder='Enter'
                  onChange={e => onUpdateHeader(localId, hi, 'key', e.target.value)}
                />
              </td>
              <td className='p-3'>
                <Input
                  value={h.value}
                  placeholder='Enter value'
                  onChange={e => onUpdateHeader(localId, hi, 'value', e.target.value)}
                />
              </td>
              <td className='p-3'>
                <TrashIcon
                  className='cursor-pointer text-red-500 hover:text-red-600'
                  aria-label='Remove header row'
                  onClick={() => onRemoveHeader(localId, hi)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default CallbackHeadersTable;
